module.exports = __webpack_public_path__ + "static/media/logo1.4755818a.png";